<template>
  <div class="c-search-filter__wrapper">
    <h2 class="c-search-filter__heading">Search results</h2>
    <div class="c-search-filter__container">
      <div class="c-search-filter__search">
        <input
          class="c-search-filter__search-input"
          v-model="searchText"
          type="text"
          placeholder="Keywords"
          v-on:keyup.enter="search"
          v-on:input="resetSort"
        />
        <button
          class="button c-search-filter__search-button"
          @click="search"
          :disabled="loading"
        >
          Search
        </button>
      </div>

      <div class="c-search-filter__filters-wrapper">
        <div class="c-search-filter__filter">
          <label class="c-search-filter__filter-label">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
            >
              <path
                d="M19.5858 3.86011H4.41421C3.63316 3.86011 3 4.49327 3 5.27432C3 5.64939 3.149 6.0091 3.41421 6.27432L8.41421 11.2743C8.78929 11.6494 9 12.1581 9 12.6885V17.624C9 18.3816 9.428 19.0741 10.1056 19.4129L14.2764 21.4983C14.6088 21.6645 15 21.4228 15 21.0511V12.6885C15 12.1581 15.2107 11.6494 15.5858 11.2743L20.5858 6.27432C20.851 6.0091 21 5.64939 21 5.27432C21 4.49327 20.3668 3.86011 19.5858 3.86011Z"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
            filter by:
          </label>
          <v-select
            class="c-search-filter__filter-select"
            :options="categoryList"
            :searchable="false"
            :clearable="false"
            :value="category"
            v-model="category"
          >
          </v-select>
        </div>

        <div class="c-search-filter__sort">
          <label class="c-search-filter__sort-label">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="24"
              height="25"
              viewBox="0 0 24 25"
              fill="none"
            >
              <path
                d="M2.99993 13.38L11.7757 17.7838C11.9168 17.8546 12.0831 17.8546 12.2242 17.7838L20.9999 13.38M2.99993 18.344L11.7757 22.7477C11.9168 22.8185 12.0831 22.8185 12.2242 22.7477L20.9999 18.344M11.7757 2.97279L2.89049 7.43143C2.52283 7.61592 2.52283 8.14071 2.89049 8.32521L11.7757 12.7838C11.9168 12.8547 12.0831 12.8547 12.2242 12.7838L21.1094 8.32521C21.477 8.14071 21.477 7.61592 21.1094 7.43143L12.2242 2.97279C12.0831 2.90197 11.9168 2.90197 11.7757 2.97279Z"
                stroke="white"
                stroke-width="2"
                stroke-linecap="round"
              />
            </svg>
            sort by:
          </label>
          <v-select
            id="project-status"
            class="c-search-filter__sort-select"
            :options="[
              { label: 'most relevant', value: '' },
              { label: 'newest first', value: 'dateDesc' },
              { label: 'oldest first', value: 'dateAsc' },
            ]"
            :reduce="(sort) => sort.value"
            :searchable="false"
            :clearable="false"
            v-model="sort"
          >
          </v-select>
        </div>
      </div>
      <!-- <button class="c-search-filter__reset-link" @click="clear">Reset</button> -->
    </div>
  </div>
</template>

<script>
import { mapFields } from "vuex-map-fields";
import vSelect from "vue-select";

export default {
  data() {
    return {};
  },
  components: {
    vSelect,
  },
  mounted() {
    this.setStateBasedOnUrlParameters();
  },
  computed: {
    ...mapFields([
      "searchApp.searchSubmission.category",
      "searchApp.searchSubmission.sort",
      "searchApp.searchSubmission.searchText",
      "searchApp.searchSubmission.start",
      "searchApp.state.loading",

      "searchApp.searchOptions.categoryList",
    ]),
  },
  watch: {
    category(newVal) {
      this.search();
    },
    // searchText(newVal) {
    //   this.sort = "";
    // },
    sort(newVal) {
      // Don't search if the sort is the same as the current value
      if (this.sort != newVal) {
        return;
      }
      this.search();
    },
  },
  methods: {
    resetSort() {
      console.log("reset sort");
      this.sort = "";
    },
    resetFilters() {
      this.sort = "dateDesc";
    },
    //Set state of filters and search based on url parameters
    setStateBasedOnUrlParameters() {
      let url = new URL(window.location.href);
      let params = new URLSearchParams(url.search);
      let shouldSearch = false;

      const paramNames = ["category", "searchText", "sort"];

      //only set param if the param is present in the url otherwise leave as the default value
      for (const paramName of paramNames) {
        const paramValue = params.get(paramName);
        //we want to accept empty strings as a valid value
        if (paramValue || paramValue === "") {
          this[paramName] = paramValue;
          shouldSearch = true;
          console.log("set params", paramName, paramValue);
        }
      }

      if (shouldSearch) {
        this.search();
      }
    },
    search() {
      this.start = 0;
      this.$store.dispatch("submitSearch");
    },
    clear() {
      this.$store.commit("resetSearchFilterFields");
    },
  },
};
</script>

<style lang="scss">
.c-search-filter__heading {
  max-width: 1440px;
  margin: auto;
  padding: 48px 16px 32px 16px;
  @media all and (min-width: 1024px) {
    padding: 48px 16px 8px 16px;
  }
}

.c-search-filter__wrapper {
  background-color: colour(dark-green);
  color: colour(white);
  border-top: 1px solid colour(green);
}

.c-search-filter__container {
  padding: 0px 16px 80px 16px;
  max-width: 1440px;
  margin: auto;
  display: flex;
  justify-content: space-between;
  gap: 32px;
  align-items: end;
  flex-wrap: wrap;
}

.c-search-filter__search {
  position: relative;
  width: 100%;
  max-width: 768px;
  min-width: 200px;
}

.c-search-filter__search-input {
  border-radius: 48px;
  background-color: colour(darkest-green);
  width: 100%;
  transition-duration: 0.3s;
  max-width: 768px;
  color: colour(white);
  &::placeholder {
    color: colour(white);
  }
  &:focus,
  &:active {
    border-color: colour(green);
    outline: none;
  }
}

.c-search-filter__search-button {
  position: absolute;
  top: 1px;
  right: 1px;
  width: 40px;
  height: 95%;
  background: #ffd4ac url("/_resources/app/client/assets/icons/search-icon.svg")
    no-repeat center center;
  text-indent: -999em;
  border-radius: 50px;
  border: none;
  padding: 0px;
}

.c-search-filter__filters-wrapper {
  display: flex;
  flex-wrap: wrap;
  gap: 32px;
}

.c-search-filter__filter {
  display: flex;
  flex-direction: column;
}

.c-search-filter__filter-label {
  @include micro-desktop;
  font-weight: 300;
  padding-bottom: 8px;
  padding-left: 8px;
  display: flex;
  align-items: center;
  gap: 5px;
  svg {
    width: 24px;
    height: 24px;
  }
}

.c-search-filter__filter .vs__dropdown-toggle {
  position: relative;
  border: 2px solid colour(white);
  background-color: colour(darkest-green);
  border-radius: 40px;
  padding: 0px 8px;
  width: 200px;
  height: 40px;
}

.c-search-filter__filter .vs__selected {
  @include sub-desktop;
  font-size: 14px;
  color: colour(white);
  height: 100%;
  margin: 0;
  padding: 0 8px;
}

.c-search-filter__filter .vs__actions {
  border-radius: 50px;
  width: 40px;
  height: 100%;
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: colour(light-wheat);

  svg path {
    fill: colour(dark-green);
  }
}

.c-search-filter__filter #vs1__listbox {
  @include sub-desktop;
  font-size: 14px;
  background-color: colour(darkest-green);
  color: colour(white);
}

.c-search-filter__sort {
  display: flex;
  flex-direction: column;
}

.c-search-filter__sort .vs__dropdown-toggle {
  position: relative;
  border: 2px solid colour(white);
  background-color: colour(darkest-green);
  border-radius: 40px;
  padding: 0px 8px;
  width: 200px;
  height: 40px;
}

.c-search-filter__sort .vs__selected {
  @include sub-desktop;
  font-size: 14px;
  color: colour(white);
  height: 100%;
  margin: 0;
  padding: 0 8px;
}

.c-search-filter__sort .vs__actions {
  border-radius: 50px;
  width: 40px;
  height: 100%;
  position: absolute;
  top: 0px;
  right: 0px;
  z-index: 2;
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: colour(light-wheat);

  svg path {
    fill: colour(dark-green);
  }
}

.c-search-filter__sort #vs2__listbox {
  @include sub-desktop;
  font-size: 14px;
  background-color: colour(darkest-green);
  color: colour(white);
}

.c-search-filter__sort-label {
  @include micro-desktop;
  font-weight: 300;
  padding-bottom: 8px;
  padding-left: 8px;
  display: flex;
  align-items: center;
  gap: 5px;
  svg {
    width: 24px;
    height: 24px;
  }
}

.c-search-filter__sort-select {
  border-radius: 48px;
  background-color: colour(darkest-green);
  color: colour(white);
}

.c-search-filter__reset-link {
  @include micro-desktop;
  background: none;
  color: colour(white);
  cursor: pointer;
}
</style>
